var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "18px",
    viewBox: "0 0 15 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2D62C586-FA0A-4424-A92D-4990F20FFE15") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Guidemark-Admin-Desktop-Worklog-details-add-work-(lettering)",
    transform: "translate(-911.000000, -475.000000)",
    fill: "#5286F7",
    fillRule: "nonzero",
    stroke: "#5286F7",
    strokeWidth: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebar-/-Work-log-details-/-Scrolled",
    transform: "translate(590.000000, -205.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(25.000000, 278.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 401.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group",
    transform: "translate(296.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.23228104,4.69375425 C1.09181294,4.57367038 1.00779729,4.40045793 1.00050394,4.21578638 C0.993305305,4.03102012 1.063492,3.85174665 1.19420405,3.72105601 L4.72153516,0.194113379 C4.85224722,0.063422739 5.03249725,-0.00627893587 5.2163466,0.000445002875 C5.40104841,0.00764245844 5.57438397,0.0916443411 5.69448751,0.232184131 L7.16272487,1.95010313 L11.6842254,3.76916532 C11.8681694,3.84312864 12.0093006,3.99550636 12.0689735,4.18453427 L14.8632752,13.031533 C14.9378189,13.2674391 14.8747361,13.5250322 14.6998851,13.6999493 C14.5736248,13.8261889 14.4041727,13.8940912 14.2309319,13.8940912 C14.1642498,13.8940912 14.0969994,13.8840527 14.0313592,13.8633126 L5.18291083,11.0694687 C4.9941361,11.0098056 4.84182814,10.8689817 4.76775798,10.6854466 L2.93684202,6.15000786 L1.23228104,4.69375425 Z M12.7821119,10.8449271 L10.8989111,4.88221394 L6.9235597,3.28286355 L4.27749305,5.92849669 L5.88051539,9.89921928 L11.8443003,11.7823009 L7.38843997,7.32707595 C7.12957327,7.06825166 7.12957327,6.64843165 7.38843997,6.38960736 C7.64749611,6.13068837 8.06729018,6.13078307 8.32615689,6.38960736 L12.7821119,10.8449271 Z M5.15231663,1.63862377 L2.63895114,4.1515775 L3.46963572,4.8612845 L5.86213993,2.46917226 L5.15231663,1.63862377 Z M14.2405235,14.9945112 C14.6014796,14.9945112 14.8940912,15.219597 14.8940912,15.4972556 C14.8940912,15.7749141 14.6014796,16 14.2405235,16 L1.65356772,16 C1.29261161,16 1,15.7749141 1,15.4972556 C1,15.219597 1.29261161,14.9945112 1.65356772,14.9945112 L14.2405235,14.9945112 Z",
    id: "Combined-Shape"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIcon);
export default __webpack_public_path__ + "static/media/sign-icon.99bc93130cb380973eaf1cb3f664ade5.svg";
export { ForwardRef as ReactComponent };